import * as Routes from '../constants/routes';

import Intro from '../calculators/loan/containers/intro';
import StepOne from '../calculators/loan/containers/step-one';
import StepTwo from '../calculators/loan/containers/step-two';
import StepThree from '../calculators/loan/containers/step-three';
import StepFour from '../calculators/loan/containers/step-four';
import StepFive from '../calculators/loan/containers/step-five';
import Summary from '../calculators/loan/containers/summary';
import Schedule from '../calculators/loan/containers/schedule';
import Contact from '../calculators/loan/containers/contact';
import ThankYou from '../calculators/loan/containers/thank-you';

export const name = 'Loan Calculator';

export const routes = [
    {
        path: Routes.HOME,
        component: Intro,
        pagination: false,
        progressBar: false
    },
    {
        path: Routes.STEPONE,
        component: StepOne,
        pagination: {
            previous: false,
            next: {
                type: 'submit'
            }
        }
    },
    {
        path: Routes.STEPTWO,
        component: StepTwo,
        pagination: {
            next: {
                type: 'submit'
            }
        }
    },
    {
        path: Routes.STEPTHREE,
        component: StepThree,
        pagination: {
            next: {
                type: 'submit'
            }
        }
    },
    {
        path: Routes.STEPFOUR,
        component: StepFour,
        pagination: {
            next: {
                type: 'submit'
            }
        }
    },
    {
        path: Routes.STEPFIVE,
        component: StepFive,
        pagination: {
            next: {
                type: 'submit'
            }
        }
    },
    {
        path: Routes.SUMMARY,
        component: Summary,
        pagination: false,
        progressBar: false
    },
    {
        path: Routes.SCHEDULE,
        component: Schedule,
        pagination: false,
        progressBar: false
    },
    {
        path: Routes.CONTACT,
        component: Contact,
        pagination: false,
        progressBar: false
    },
    {
        path: Routes.THANKYOU,
        component: ThankYou,
        pagination: false,
        progressBar: false
    }
];
